import { render, staticRenderFns } from "./duration.vue?vue&type=template&id=1dc0786e&scoped=true"
import script from "./duration.vue?vue&type=script&lang=js"
export * from "./duration.vue?vue&type=script&lang=js"
import style0 from "./duration.vue?vue&type=style&index=0&id=1dc0786e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc0786e",
  null
  
)

export default component.exports